var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { attrs: { id: "main-view" } }, [
    !_setup.resetting
      ? _c(
          "div",
          { staticClass: "main-view-content" },
          [
            _c(_setup.MainSectionHero),
            _vm._v(" "),
            _c(_setup.MainSectionInfo),
            _vm._v(" "),
            _c(_setup.MainSectionPromotions),
            _vm._v(" "),
            _c(_setup.MainSectionPhysics),
            _vm._v(" "),
            _c(_setup.MainSectionTraining),
            _vm._v(" "),
            _c(_setup.MainSectionProficiency),
            _vm._v(" "),
            _c(_setup.MainSectionStories),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$env.isDevelopment
      ? _c(
          "div",
          { staticClass: "theme-toggle" },
          [
            _c(
              "b-button",
              {
                attrs: { variant: "primary" },
                on: { click: _setup.resetPage },
              },
              [_vm._v("Reset Page")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }